//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import universalImageActionsTributaryCustomizeMediaTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-customize-media.html';

export class UniversalImageActionsTributaryCustomizeMedia {
  public state;
  public universalItemId: string;

  constructor(
        private ShowroomService,
        private UniversalImageActionsService,
        private SHOWROOM_PREVIEW_SECTIONS,
    ) { }

  public onLabelsUpdated = (newLabels) => {
    this.updatePreviewForMedia(
            newLabels,
            null,
            () => { this.ShowroomService.updateLabels(newLabels); },
        );
  }

  public onUpdateCuratedMediaState = (newCuratedMediaState) => {
    this.updatePreviewForMedia(
            null,
            newCuratedMediaState,
            () => { this.ShowroomService.onUpdateCuratedMediaState(newCuratedMediaState); },
        );
  }

  public $onInit() {
    const launchOptions = this.UniversalImageActionsService.getCurrentLaunchOptions();
    this.universalItemId = launchOptions.getUniversalItemId();

    this.state = {
            // Since this is step 3, we have already loaded
      loaded: true,
    };

    this.ShowroomService.getCurrentConfigStatusObservable().subscribe((currentState) => {
      this.state = angular.copy(currentState);
    });

    this.ShowroomService.loadExistingState(this.universalItemId);
  }

    //
    // Private helpers
    //

  private updatePreviewForMedia = (newLabels, newCuratedMediaState, callback) => {
    const labels = newLabels || this.state?.selectedLabels;

    const curatedMediaState = newCuratedMediaState || this.state?.curatedMediaState;
    const curatedRecsBoolean = this.ShowroomService.getCuratedRecsBoolean(
            this.state.curatedProductsState,
            curatedMediaState,
        );

    this.ShowroomService.updatePreview(
            this.universalItemId,
            this.state.impl.id,
            this.state.impl.name,
            this.state.impl.implementationType,
            this.state.impl.sourceId,
            this.state?.filters?.filterState,
            this.state?.passthrough?.showDesktopExperience,
            this.state?.passthrough?.passthroughUrl,
            this.state?.emailCaptureState,
            this.state?.customStringsState,
            this.state?.curatedRecsId,
            curatedRecsBoolean,
            this.state?.curatedProducts,
            labels,
            this.state?.curatedProductsState,
            curatedMediaState,
            this.SHOWROOM_PREVIEW_SECTIONS.MEDIA,
            callback,
        );
  }
}

angular.module('uia').component('universalImageActionsTributaryCustomizeMedia', {
  template: universalImageActionsTributaryCustomizeMediaTemplate,
  controller: [
    'ShowroomService',
    'UniversalImageActionsService',
    'SHOWROOM_PREVIEW_SECTIONS',
    UniversalImageActionsTributaryCustomizeMedia,
  ],
});
